import {Component, computed, input, output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Card} from 'primeng/card';
import {SelectButton} from 'primeng/selectbutton';
import {InputText} from 'primeng/inputtext';
import {TranslocoDirective} from '@jsverse/transloco';
import {TooltipModule} from 'primeng/tooltip';
import {DirectusTooltipComponent} from '../../../../../../../shared/components/directus-tooltip/directus-tooltip.component';
import {FormsModule} from '@angular/forms';
import {ProjectStepSaveButtonComponent} from '../../../../../../../shared/project-step-save-button/project-step-save-button.component';

interface Category {
  nameKey: string;
  tooltipKey: string;
  baseValue: number;
}

type ScaleType = 'linear' | 'exp';

@Component({
  selector: 'app-importance-scale-tab',
  imports: [
    CommonModule,
    Card,
    TranslocoDirective,
    SelectButton,
    InputText,
    TooltipModule,
    DirectusTooltipComponent,
    FormsModule,
    ProjectStepSaveButtonComponent,
  ],
  templateUrl: './step-1-3-importance-scale-tab.component.html',
})
export class Step13ImportanceScaleTabComponent {
  readonly selectedScale = input.required<ScaleType>();
  readonly originalScale = input<ScaleType | null>(null);
  readonly isSaving = input(false);
  readonly disabled = input<boolean>(false);

  readonly scaleChange = output<ScaleType>();
  readonly submitOutput = output<void>();

  readonly scaleOptions = scaleOptions;

  readonly categoryValues = computed(() =>
    categories.map((cat) => ({
      ...cat,
      displayValue: this.selectedScale() === 'exp' ? cat.baseValue ** 2 : cat.baseValue,
    })),
  );

  readonly shouldShowSaveButton = computed(() => {
    const original = this.originalScale();
    const current = this.selectedScale();

    if (original === null) {
      return true;
    }

    return original !== current;
  });

  onScaleChange(scale: ScaleType): void {
    this.scaleChange.emit(scale);
  }

  onSubmit(): void {
    this.submitOutput.emit();
  }
}

const scaleOptions = [
  {labelKey: 'steps.scale.linear', value: 'linear' as const},
  {labelKey: 'steps.scale.exp', value: 'exp' as const},
];

const categories: Category[] = [
  {nameKey: 'steps.category.basic', tooltipKey: 'projectSetting_basicFeature', baseValue: 4},
  {
    nameKey: 'steps.category.performance',
    tooltipKey: 'projectSetting_performanceFeature',
    baseValue: 3,
  },
  {
    nameKey: 'steps.category.enthusiasm',
    tooltipKey: 'projectSetting_enthusiasmFeature',
    baseValue: 2,
  },
  {
    nameKey: 'steps.category.indifferent',
    tooltipKey: 'projectSetting_indifferentFeature',
    baseValue: 1,
  },
];
